import type { ApolloError } from '@apollo/client';
import { type ExtendedGQLError, NestedErrorCode } from '../../../graphql/types';

export const isAudienceNamePath = (path?: string): boolean => path === 'name' || !!path?.endsWith('.name');

export const isAudienceNameConflictError = (error: unknown): boolean => {
  const apolloError = error as ApolloError | undefined;

  return !!apolloError?.graphQLErrors?.some(err => {
    const extendedErr = err as ExtendedGQLError;

    return extendedErr.extensions?.errors?.some(
      nestedErr => nestedErr.code === NestedErrorCode.JOINT_UNIQUENESS_VIOLATION && isAudienceNamePath(nestedErr.path)
    );
  });
};
